/* eslint-disable @typescript-eslint/no-confusing-void-expression */
import React from 'react'
import { Layout, Menu } from 'antd'
import styled from '@emotion/styled'
import SideIconBlack from 'assets/header/side-icon-black.svg'
import SideIconWhite from 'assets/header/side-icon-white.svg'
import { Link, useLocation } from 'react-router-dom'
import './layout.scss'
import SubMenu from 'antd/es/menu/SubMenu'
import queryString from 'query-string'

const { Sider } = Layout

const listMenu = [
  {
    title: '案件予実管理',
    path: '/forecast-received'
  },
  {
    title: 'イベデパサイト業務 ',
    path: '/ec-site-business'
  },
  {
    title: 'スぺコネサイト業務',
    path: '/site-business-management'
  }
]

const listMenuB2CAdmin = [
  {
    title: 'コール業務',
    path: '/call-work-business-list?type=コール',
    subpath: '/call-work-detail'
  },
  {
    title: 'チャット業務',
    path: '/call-work-business-list?type=チャット'
  },
  {
    title: '遠隔接客業務 ',
    path: '/call-work-business-list?type=遠隔接客'
  }
]

const listMenuB2CUser = [
  {
    title: 'マルチセンタ管理者ダッシュボード',
    path: '/dashboard',
    isLink: false
  },
  {
    title: '業務テーブル（外部リンク）',
    path: `${process.env.REACT_APP_URL}/admin/data/T_Multi_operation`,
    isLink: true
  },
  {
    title: 'マルチセンタ商材マスタ（外部リンク）',
    path: `${process.env.REACT_APP_URL}/admin/data/T_agg_product`,
    isLink: true
  },
  {
    title: 'ヒストリカルレポート',
    path: '/dashboard-history-report',
    isLink: false
  },
  {
    title: 'オペレータ成績 ',
    path: '/dashboard-operator-performance',
    isLink: false
  },
  {
    title: '商材獲得件数 ',
    path: '/dashboard-products-acquired',
    isLink: false
  }
]

const Sidebar = () => {
  const router = useLocation()
  // const splitStr = router?.pathname.split('/')
  // const output = `/${splitStr[1]}`
  const roleUser: any = localStorage.getItem('role-user')
  const queryObj: any = queryString.parse(router.search)
  return (
    <Sider
      breakpoint="lg"
      collapsedWidth="0"
      onBreakpoint={(broken) => {
      }}
      onCollapse={(collapsed, type) => {
      }}
      width={245}
      className='h-[85vh] md:h-[90vh]'
      style={{ background: '#262626' }}
    >
      <FlexCol className='relative h-full' >
        {(roleUser === 'b2b' || roleUser === 'all') &&
          listMenu?.map((item, index) => (
            <Link
              to={item?.path}
              className="hover:text-white hover:font-bold"
              style={{ borderTop: '1px solid #171717' }}
            >
              <FlexRow
                className={`${router?.pathname === item?.path ? 'is-side-active' : ''
                  }`}
                style={{
                  padding: '15px 30px 15px 30px',
                  width: '226px'
                }}
              >
                <img
                  src={
                    router?.pathname === item?.path
                      ? SideIconBlack
                      : SideIconWhite
                  }
                  alt=""
                />
                <p className="ml-[5px]" style={{ whiteSpace: 'nowrap' }}>
                  {item?.title}
                </p>
              </FlexRow>
            </Link>
          ))}

        {(roleUser === 'b2c-user' || roleUser === 'all') && (
          <Menu
            theme="dark"
            className="ant-menu"
            style={{ background: '#262626' }}
            mode="inline"
            defaultSelectedKeys={['1']}
          >
            <SubMenu
              style={{ background: '#262626' }}
              key="3"
              title={
                <FlexRow>
                  <img src={SideIconWhite} alt="" />
                  <p
                    className="ml-[5px]"
                    style={{ whiteSpace: 'nowrap', color: 'white' }}
                  >
                    マルチセンタ管理者用
                  </p>
                </FlexRow>
              }
            >
              {listMenuB2CUser?.map((item, index) => (
                <div style={{ width: '100%', background: '#262626' }}>
                  <Link
                    to={item?.path}
                    className="hover:text-white hover:font-bold"
                    style={{
                      borderTop: '1px solid #171717',
                      background: '#262626'
                    }}
                  >
                    <FlexRow
                      className={`${router?.pathname === item?.path ? 'is-side-active' : ''
                        }`}
                      style={{
                        padding: '15px 30px 15px 30px',
                        width: '226px'
                      }}
                    >
                      <p className="ml-[15px]" style={{
                        whiteSpace: 'normal',
                        wordBreak: 'break-word',
                        overflowWrap: 'break-word',
                        lineHeight: '1.3'
                      }}>
                        {item?.title}
                      </p>
                    </FlexRow>
                  </Link>
                </div>
              ))}
            </SubMenu>
          </Menu>
        )}

        {(roleUser === 'b2c-user' || roleUser === 'all') &&
          listMenuB2CAdmin?.map((item, index) => (
            <>
              <Link
                to={item?.path}
                className="hover:text-white hover:font-bold"
                style={{ borderTop: '1px solid #171717' }}
              >
                <FlexRow
                  className={`${item?.path.includes(queryObj?.type)
                    ? 'is-side-active'
                    : ''
                    }`}
                  style={{
                    padding: '15px 30px 15px 30px',
                    width: '226px'
                  }}
                >
                  <img
                    src={
                      item?.path.includes(queryObj?.type)
                        ? SideIconBlack
                        : SideIconWhite
                    }
                    alt=""
                  />
                  <p className="ml-[5px]" style={{ whiteSpace: 'nowrap' }}>
                    {item?.title}
                  </p>
                </FlexRow>
              </Link>
            </>
          ))}
        <div className="absolute bottom-0 w-full">
          <hr />
          <FlexCol>
            <p style={{ padding: '15px 30px 15px 30px' }}>R2事業再構築</p>
          </FlexCol>
        </div>
      </FlexCol>

      {/* <Menu
          theme="dark"
          mode="inline"
          defaultSelectedKeys={['4']}
          items={[UserOutlined, VideoCameraOutlined, UploadOutlined, UserOutlined].map(
            (icon, index) => ({
              key: String(index + 1),
              icon: React.createElement(icon),
              label: `nav ${index + 1}`,
            }),
          )}
        /> */}
    </Sider>
  )
}

const FlexCol = styled.div({
  display: 'flex',
  flexDirection: 'column',
  padding: '10px 0px',
  color: '#fff'
})

const FlexRow = styled.div({
  display: 'flex',
  flexDirection: 'row'
})

export default Sidebar
